class Movie {
	constructor($dom, movieID){
		this.dom 		= $dom;
		this.movieID 	= movieID;
		this.player 	= null;
		this.isPlaying 	= false;
		
		this.isReady = false;
		this._resolveReady = null;
		this.ready = new Promise(res => this._resolveReady = res);
		this.setPlayer();
	}
	setPlayer(){
		let $this = this;
		let player = $this.dom.querySelector(".player");
		//console.log(player, this.movieID)
		
		let w = 560;
		let h = 315;
		//console.log($this.hasControll)
		//console.log($this.movieID, $this.player);
		$this.player = new YT.Player(player, {
			height: h,
			width: w,
			videoId: $this.movieID,
			playerVars 	: {
				autohide	: 1,
				controls	: 0,
				frameborder : 0,
				rel			: 0,
				start		: 0,
				showinfo 	: 0,
				disablekb	: 1,
				wmode		: "transparent",
				autoplay	: 0,
				mute 		: 1,
				playsinline	: 1,
				loop		: 1,
				enablejsapi	: 1,
				iv_load_policy: 3,
				modestbranding: 1,
				vq: 'hd1080',
				origin: location.protocol + '//' + location.hostname + "/"
			},
			events: {
				'onReady': $this.onPlayerReady.bind($this),
				'onStateChange': $this.onPlayerStateChange.bind($this)
			}
		});
	}
	onPlayerReady(e){
		this.player = e.target;
		this.isReady = true;
		// 念のためミュート（モバイル自動再生対策）
		try { this.player.mute?.(); } catch {}
		this._resolveReady?.();
	}
	onPlayerStateChange(e){
		let $this = this;
		//console.log(e.data);
		if( e.data === 0){
			$this.player.seekTo(0);
		}else if( e.data === 2){
			if( !$this.dom.classList.contains("pause") ){
				$this.dom.classList.add("pause");
				$this.isPlaying = false;
			}
		}else if( e.data === 1){
			if( $this.dom.classList.contains("pause") ){
				$this.dom.classList.remove("pause");
				$this.isPlaying = true;
			}
		}
	}
	playVideo(){
		let $this = this;
		//console.log($this);
		//console.log("yt play", $this.dom)
		if( !$this.isPlaying ){
			if( $this.player ){
				$this.player.playVideo();
				$this.isPlaying = true;
			}
		}
		
	}
	pauseVideo(){
		let $this = this;
		//console.log("yt stop", $this.dom)
		if( $this.isPlaying ){
			if( $this.player ){
				$this.player.pauseVideo();
				$this.isPlaying = false;
			}
		}
	}
}
export let ytMovie = {
	players:[ ],
	canPlay: false,
	beforeW: 0,
	init: function(){
		let tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},
	setup: function(){
		const $movies = document.querySelectorAll("[data-movie-id]");
		ytMovie.players = []; // ← 二重挿入対策として毎回作り直すのが安全
		$movies.forEach(($m, i) => {
			const movieID = $m.getAttribute("data-movie-id");
			ytMovie.players.push(new Movie($m, movieID));
		});
		
		// 全部の onReady を待つ
		Promise.all(ytMovie.players.map(p => p.ready)).then(() => {
			ytMovie.canPlay = true;
			ytMovie.resize(); // 初回判定は ready 後に
		});
	},
	resize: function(beforeW){
		const width = window.innerWidth;
		let isMobile = window.innerWidth < 960;
		let ratio = 540 / 315;
		if( isMobile ){
			ratio = 700 / 1400;
		}
		
		let kv = document.querySelector(".yt_kv");
		let container = document.querySelector(".i-kv");
		const iframe = kv.querySelector('iframe');
		
		if (!iframe) return;
	
		const cw = container.clientWidth;
		const ch = container.clientHeight;
		const cr = cw / ch;
		//console.log(cw, ch, cr)
		let w, h;
		if (cr > ratio) {
			// コンテナの方が横長 → 幅を合わせ、高さをオーバーさせてカバー
			w = cw;
			h = Math.ceil(cw / ratio);
		} else {
			// コンテナの方が縦長 → 高さを合わせ、幅をオーバーさせてカバー
			h = ch;
			w = Math.ceil(ch * ratio);
		}
		//console.log(w, h);
		iframe.style.width  = w + 'px';
		iframe.style.height = h + 'px';
		//console.log("players", ytMovie.players);
		//console.log(ytMovie.canPlay, "can play?")
		if( !ytMovie.canPlay ){ return }
		
		if( beforeW != width && ytMovie.players.length > 0 ){
			let pageContent = document.querySelectorAll("#page_content [data-page]");
			
			//console.log(pageContent.length);
			if( pageContent.length > 0 ){
				//ytMovie.players[0].pauseVideo();
				//ytMovie.players[1].pauseVideo();
			}else{
				if( isMobile ){
					ytMovie.players[1].pauseVideo();
					ytMovie.players[0].playVideo();
					
				}else{
					//console.log(ytMovie.players);
					ytMovie.players[0].pauseVideo();
					ytMovie.players[1].playVideo();
				}
			}
		}
	}
}
window.onYouTubeIframeAPIReady = function() {
	ytMovie.setup();
}